import * as React from 'react'
import * as cn from 'classnames'
import * as styles from './ReviewsRating.module.scss'

export const MAX_STARS = 5

const sanitiseNumber = (number: number) => {
    if (number > MAX_STARS) {
        return MAX_STARS
    }
    if (number < 0.5) {
        return 0.5
    }
    return Math.round(number * 2) / 2
}

const FullStar = () => <div className={cn(styles.fullStar, 'tst-full-star')} />
const HalfStar = () => <div className={cn(styles.halfStar, 'tst-half-star')} />
const EmptyStar = () => <div className={cn(styles.emptyStar, 'tst-empty-star')} />


export const ReviewsRating = ({ rating, className, link }: { rating: number, className?: string, link?: string }) => {
    const value = sanitiseNumber(rating)
    const hasHalfStar = Boolean((value * 2) % 2)
    const baseNumber = Math.floor(value)
    const emptyStars = MAX_STARS - baseNumber - (hasHalfStar ? 1 : 0)

    const Tag = link ? 'a' : 'div'
    
    return <Tag className={cn(className, styles.rating)} href={link}>
        {[...Array(baseNumber)].map((_, idx) => <FullStar key={idx}/>)}
        {hasHalfStar && <HalfStar />}
        {[...Array(emptyStars)].map((_, idx) => <EmptyStar key={idx}/>)}
    </Tag>
}
